import axios from 'axios'
import { API_CONFIG } from '../config/api'

const api = axios.create({
  baseURL: API_CONFIG.baseURL,
  timeout: API_CONFIG.timeout,
  headers: API_CONFIG.headers,
})

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // Add any auth headers here if needed
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor
api.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    // Don't log errors for onboarding endpoint since it's not implemented yet
    if (!error.config?.url?.includes('/api/auth/onboarding')) {
      // Silent error handling for privacy
    }
    return Promise.reject(error)
  }
)

export { api }
